<template>
     <div class="businessopportunity-search">
          <PageTitle 
                icon="fa fa-clone" 
                main="Record" sub="Business Opportunity" 
                />
    <b-card class="businessopportunity-search-card">
        <b-tabs card >
            <b-tab title="Registration" active>
            <b-form 
                v-show="mode === 'save' || mode === 'remove' || mode === 'read'" >
             <input 
                id="businessopportunity-id" 
                type="hidden" 
                v-model="businessopportunity.id" />
             <b-row>
                <b-col md="2" sm="12">
                    <b-form-group
                    label="Opportunity Date:"
                    label-for="businessopportunity-date_opportunity"
                    >
                    <b-form-input
                    id="businessopportunity-date_opportunity"
                    type="date"
                    v-model="businessopportunity.date_opportunity"
                    :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
               
                 <b-col md="6" sm="12">
                    <b-form-group 
                        label="Landlord:" 
                        label-for="businessopportunity-owner_id_opportunity">
                        <b-select 
                            id="businessopportunity-owner_id_opportunity"
                            size="sm"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="owners" 
                            @input="loadOwnerImmobiles()"
                            v-model="businessopportunity.owner_id_opportunity" 
                            />
                    </b-form-group>
                </b-col> 
             </b-row>
             <b-row>
                 <b-col md="6" sm="12">
                      <b-form-group 
                        label="Property:" 
                        label-for="businessopportunity-immobile_id_opportunity">
                        <b-select 
                            id="businessopportunity-immobile_id_opportunity"
                            size="sm"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="immobiles" 
                           @input="[loadImmobileItems(businessopportunity.immobile_id_opportunity),loadImmobileDetail()]"
                            v-model="businessopportunity.immobile_id_opportunity" 
                            />
                    </b-form-group>
                </b-col> 
                <b-col md="6" sm="12">
                    <b-form-group 
                        label="Location:" 
                        label-for="businessopportunity-immobile_item_id_opportunity">
                        <b-select 
                            id="businessopportunity-immobile_item_id_opportunity"
                            size="sm"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="immobile_items" 
                            v-model="businessopportunity.immobile_item_id_opportunity" 
                            />
                    </b-form-group>
                </b-col> 
             </b-row>
             <b-row>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Value Opportunity:"
                        label-for="businessopportunity-value_opportunity"
                    >
                        <b-form-input
                            id="businessopportunity-value_opportunity"
                            type="number"
                            v-model="businessopportunity.value_opportunity"
                            size="sm"
                            step="0.02"
                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Percent Parther:"
                        label-for="businessopportunity-percent_opportunity"
                    >
                        <b-form-input
                            id="businessopportunity-percent_opportunity"
                            type="number"
                            v-model="businessopportunity.percent_opportunity"
                            size="sm"
                            step="0.02"
                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                        />
                    </b-form-group>
                </b-col>
                  <b-col md="2" sm="12">
                    <b-form-group
                        label="Rent Payment Day:"
                        label-for="businessopportunity-rent_payment_day_opportunity"
                    >
                        <b-form-input
                            id="businessopportunity-rent_payment_day_opportunity"
                            type="number"
                            v-model="businessopportunity.rent_payment_day_opportunity"
                            size="sm"
                        />
                    </b-form-group>
                </b-col>
             </b-row>
          
        <br>
         </b-form>
            <hr v-show="mode === 'save'">
              <b-row>
                <b-col xs="12">
                   <b-button  
                        size="sm" 
                        variant="light" 
                        title="Add"
                        class="mt-2  mb-2 fa fa-plus" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo">
                    </b-button>
                    <b-button 
                        size="sm" 
                        variant="light"
                         title="Save"
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save">
                        </b-button>
                    <b-button 
                        size="sm" 
                        variant="light" 
                         title="Delete"
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove">
                    </b-button>
                    <b-button 
                        size="sm" 
                        btn-sm 
                        variant="light" 
                         title="Back"
                        class="mt-2 mb-2 ml-2 fa fa-mail-reply"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset">
                    </b-button>
                    <b-button 
                         size="sm" 
                         class="mt-2 mb-2 ml-2 fa" 
                          title="Search"
                         :class="icon" 
                         @click="[loadBusinessOpportunity(),toggleBusy(),showTable = !showTable]" 
                         variant="light" >
                    </b-button>
                </b-col>
            </b-row>
            <br>
             <b-row v-show="mode !== 'save' && mode !== 'remove'">
                 <b-col md="9" sm="12">
                             <div class="form-group">
                        <input 
                            type="text" 
                            size="sm" 
                            icon="search" 
                            v-model="search" 
                           
                              v-show="mode !== 'save' && mode !== 'remove'"
                            placeholder="Search by landlord name" 
                            class="form-control">
                    </div>
                     </b-col>
                   
             </b-row>
              <b-row v-show="mode !== 'save' && mode !== 'remove'">
                 <b-col md="2" sm="12">
                    <b-form-group
                    label="Start Opportunity:"
                    label-for="orderservice-start_date"
                    >
                    <b-form-input
                    id="orderservice-start_date"
                    type="date"
                    v-model="start_date"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
                 <b-col md="2" sm="12">
                    <b-form-group
                    label="End Opportunity:"
                    label-for="orderservice-end_date"
                    >
                    <b-form-input
                    id="orderservice-end_date"
                    type="date"
                    v-model="end_date"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
                 <b-col md="4" sm="12">
                    <b-form-group 
                        label="Situation">
                    <b-form-radio-group
                        size="lg"
                        v-model="receipt"
                        @input="loadBusinessOpportunity"
                        :options="optionsReceipt"
                        name="orderservice-receipt"
                    ></b-form-radio-group>  
                    </b-form-group>    
                </b-col>
             </b-row>
            <b-row v-show="mode !== 'save' && mode !== 'remove'">

          <transition  name="slide" type="animation" appear>       
         <b-table 
                 :busy="isBusy"  
                class="table-responsive" 
                :per-page="perPage" 
                :current-page="currentPage" 
                hover 
                 head-variant="dark" 
                v-show="showTable"
                :items="filteredList" 
                :fields="fields">
                <template v-slot:table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
               <template v-slot:cell(actions)="data">  
                    <b-button  
                        v-if="!data.item.date_closed_opportunity"
                        title = "Closed" 
                        size="sm" 
                        variant="light" 
                        @click="[loadOwner(data.item),showMsgBoxClosed(data.item)]" 
                        class="mr-2 mt-2">
                        <i class="fa fa-handshake-o"></i>
                    </b-button>                 
                    <b-button  
                        title = "View" 
                        size="sm" 
                        variant="light" 
                        @click="loadOwner(data.item, 'read')" 
                        class="mr-2 mt-2">
                        <i class="fa fa-drivers-license-o"></i>
                    </b-button>
                    <b-button  
                        title = "Edit" 
                        size="sm" 
                        variant="light" 
                        @click="loadOwner(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-pencil"></i>
                    </b-button>
                     <b-button  
                        title = "Delete" 
                        size="sm" 
                        variant="light" 
                        @click="loadOwner(data.item, 'remove')" class="mr-2 mt-2">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>    
         </b-table> 
          </transition>
          <transition  name="slide" type="animation" appear>
            <b-pagination
                v-show="showTable"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                size="sm"
                aria-controls="my-table"
            ></b-pagination>
          </transition>
        </b-row>
        </b-tab>
        
    </b-tabs>
</b-card>
         <b-modal
            id="modalOpportunityClosed"
            ref="modal"
            title-tag="h6"
            title="Closed Opportunity"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="save"
        >
             <b-form>
                <b-row>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Closed Date:"
                            label-for="businessopportunity-date_closed_opportunity"
                        >
                            <b-form-input
                                id="businessopportunity-date_closed_opportunity"
                                type="date"
                                v-model="businessopportunity.date_closed_opportunity"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                     <b-col md="4" sm="12">
                    <b-form-group
                        label="Closed Value:"
                        label-for="businessopportunity-value_closed_opportunity"
                    >
                        <b-form-input
                            id="businessopportunity-value_closed_opportunity"
                            type="number"
                            v-model="businessopportunity.value_closed_opportunity"
                            size="sm"
                            step="0.02"
                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                        />
                    </b-form-group>
                </b-col>
                </b-row>
                <b-row>
                     <b-col md="12" sm="12">
                        <b-form-group 
                            label="Parther:" 
                            label-for="businessopportunity-parther_id_opportunity">
                            <b-select 
                                id="businessopportunity-parther_id_opportunity"
                                size="sm"
                                :options="parthers" 
                                v-model="businessopportunity.parther_id_opportunity" 
                                />
                        </b-form-group>
                    </b-col> 
                </b-row>
             </b-form>
         </b-modal>

            
     </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'

var moment = require('moment-timezone')

export default {
    name: 'BusinessOpportunity',
    components: {PageTitle },
    data: function() {
        return {
                mode: 'insert',
                search: '',
                businessopportunity: {},
                immobile: {},
                parthers:[],
                owners:[],
                immobiles:[],
                immobile_items:[],
                businessopportunitys: [],
                perPage: 20,
                currentPage: 1,
                 isBusy: false,
                 showTable: false,
                start_date: null,
                 end_date: null,
                 receipt: null,
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
                fields: [
                    {
                        key: 'date_opportunity',label: 'Opportunity Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                    { key: 'name_owner', label: 'Landlord', sortable: false ,variant: 'light'},
                    { key: 'address_immobile', label: 'Address', sortable: false ,variant: 'light'},
                    { key: 'name_type_part_immobile', label: 'Location', sortable: false ,variant: 'light'},
                    { key: 'description_item', label: 'Description', sortable: false ,variant: 'light'},
                    { key: 'pet_allowed_immobile', label: 'Pets Allowed', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' }, 
                    { key: 'rent_payment_day_opportunity', label: 'Rent Pay. day', sortable: false ,variant: 'light'},
                    { key: 'value_opportunity', label: 'Value', sortable: false ,variant: 'light' ,formatter: value => (value ? this.formatPrice(value) : 0)},
                    { key: 'percent_opportunity', label: '% Parther', sortable: false ,variant: 'light' ,formatter: value => (value ? this.formatPrice(value) : 0)},
                    {
                        key: 'date_closed_opportunity',label: 'Closing Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },  
                    { key: 'name_parther', label: 'Parther', sortable: false ,variant: 'light'},    
                    { key: 'value_closed_opportunity', label: 'Closing Value', sortable: false ,variant: 'light' ,formatter: value => (value ? this.formatPrice(value) : 0)},       
                { key: 'actions', label: 'Action',variant: 'light' },
                //{ key: 'accesses', label: 'Acessos',variant: 'secondary' }
                ],
                         optionsReceipt: [
                        { text: 'Open', value: 0 },
                        { text: 'Closed', value: 1 },
                        { text: 'All', value: 2 }     
                ],

            }
        },
        computed: {
            filteredList() {
                return this.businessopportunitys.filter(businessopportunity => {
                    return businessopportunity.name_owner.toLowerCase().includes(this.search.toLowerCase())
                    })
            },
            compan(){
                return this.$store.state.compan
            },
            icon() {
            return this.showTable ? "fa-retweet" : "fa-search";
            },
            rows() {
                return this.businessopportunitys.length
            },
            user(){
                    return this.$store.state.user
            },
        },
        methods:{
            formatDateTime(date) {
                return moment(date)
                    .format('YYYY-MM-DD LT')
            },
            formatDate(value) {
                return moment(value)
                    .format('YYYY-MM-DD')
            },
            formatPrice(value) {
                let val = (value / 1).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
               async showMsgBoxClosed() {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to closed the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        this.openModalFinancial()
                    }
                })
            },
             async showMsgBoxCanceled(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to cancel the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.canceled(item)
                    }
                })
            },
            loadBusinessOpportunity(){
                const url = `${baseApiUrl}/businessopportunitysbycompany/${this.compan.id}/?start_date=${this.start_date}&end_date=${this.end_date}&receipt=${this.receipt}`
                axios(url).then(res =>{
                     this.businessopportunitys = res.data
                      this.isBusy = false
                })
            },
            alterModo() {
                    this.mode = 'save'
                    this.businessopportunity = {}
            },
             reset() {
                this.mode = 'insert'
                this.loadBusinessOpportunity()              
                this.businessopportunity = {}
            },
            openModalFinancial() {
                this.$bvModal.show('modalOpportunityClosed')
            },
            async save() {

                const method = this.businessopportunity.id ? 'put' : 'post'
                const id = this.businessopportunity.id ? `/${this.businessopportunity.id}` : ''

                 this.businessopportunity.user_id_opportunity = this.user.id
                 this.businessopportunity.company_id_opportunity = this.compan.id
 

                await axios[method](`${baseApiUrl}/businessopportunitys${id}`, this.businessopportunity)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)
            },
            remove() {
                    const id = this.businessopportunity.id
                    axios.delete(`${baseApiUrl}/businessopportunitys/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.reset()
                        })
                        .catch(showError)
            },
            loadOwner(businessopportunity, mode = 'save') {
                this.mode = mode
                 if(businessopportunity.date_opportunity) businessopportunity.date_opportunity = this.formatDate(businessopportunity.date_opportunity)
                this.businessopportunity = { ...businessopportunity }
            },
             openModalImmobile() {
                this.$bvModal.show('modalImmobile')
            },
            loadOwners() {
                const url = `${baseApiUrl}/ownersbycompany/${this.compan.id}`
                axios.get(url).then(res => {
                    this.owners = res.data.map(type => {
                        return { value: type.id, text: type.name_owner }
                    })
                })
            },
            loadOwnerImmobiles(){
                const url = `${baseApiUrl}/immobilebyowner/${this.businessopportunity.owner_id_opportunity}`
                axios(url).then(res =>{
                     this.immobiles = res.data.map(imobile =>{
                        return {value: imobile.id , text: imobile.address_immobile + ' / ' + imobile.region_immobile}
                     })
                })
            },
            loadImmobileItems(id){
                const url = `${baseApiUrl}/immobileitemsbyidimmobileallocatable/${id}`
                axios(url).then(res =>{
                     this.immobile_items = res.data.map(imobile =>{
                        return {value: imobile.id, text: imobile.name_type_part_immobile + ' / ' + imobile.description_item + ' - ' + imobile.status}
                     })
                })
            },
             loadImmobileDetail(){
                const url = `${baseApiUrl}/ownercontractslastidimmobile/?owner_id_contract=${this.businessopportunity.owner_id_opportunity}&immobile_id_contract=${this.businessopportunity.immobile_id_opportunity}`
                axios(url).then(res =>{
                    this.businessopportunity = {
                        ...this.businessopportunity,
                        rent_payment_day_opportunity: res.data.day_for_payment_contract
                    }
                })
            },
            loadParthers() {
                const url = `${baseApiUrl}/parthersbycompany/${this.compan.id}`
                axios.get(url).then(res => {
                    this.parthers = res.data.map(type => {
                        return { value: type.id, text: type.name_parther }
                    })
                })
            },
           async canceled(item){
                 const method = 'put'

                await axios[method](
                    `${baseApiUrl}/businessopportunityfinancialdetailcanceled/${item.id}`,
                    this.item
                )
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.loadBusinessOpportunity()

                    })
                    .catch(showError)
           },
            async printerPaymentReceipt(item) {
    
            const url = `${baseApiUrl}/tenantpaymentreceiptprinter/${item.id}`
            await axios.get(url)
            window.open(url)
            
            },
        async printerAgreement(item) {
    
            const url = `${baseApiUrl}/businessopportunityprinter/${item.id}`
            await axios.get(url)
            window.open(url)
            
            },
          

        },
        mounted(){

                this.start_date = moment()
                .add(-30, "d")
                .format("YYYY-MM-DD");
                this.end_date = moment()
                .add(30, "d")
                .format("YYYY-MM-DD");

            this.loadBusinessOpportunity()
            this.loadOwners()
            this.loadParthers()
            this.showTable = true
        }
}
</script>

<style>


    .businessopportunity-search{
        font-size: 0.75rem;
        color: white;
   
    }

    .businessopportunity-search button{
        font-size: 0.75rem;
    }

     .businessopportunity-search select{
        font-size: 0.75rem;
    }

    .businessopportunity-search input{
        font-size: 0.75rem;
    }

    .businessopportunity-search-card label{
        font-size: 0.75rem;
        color: black;
   
    }


  

 #modalOpportunityClosed {
        font-size: 0.75rem;
    }

    #modalOpportunityClosed button{
        font-size: 0.75rem;
    }

     #modalOpportunityClosed input{
        font-size: 0.75rem;
    }

      #modalOpportunityClosed select{
        font-size: 0.75rem;
    }

      #modalOpportunityClosed label{
        font-size: 0.75rem;
        color: black;
    }
    



    
@keyframes slide-in {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(40px);
  }
}

.slide-enter-active {
  animation: slide-in 1s ease;
  transition: opacity 1s;
}

.slide-leave-active {
  animation: slide-out 1s ease;
  transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

</style>
